import React from "react";
import PropTypes from "prop-types";
import { useMouseEnterLeave } from "../utils";

export default function Tooltip({
  className,
  controlled,
  open,
  children,
  placement,
  tooltipChildren,
}) {
  const [entered, callbackAttrs] = useMouseEnterLeave();

  const style = placement === "top" ? { bottom: "100%" } : {};
  const isOpened = (!controlled && entered) || (controlled && open);

  return (
    <div className={`relative ${className}`} {...callbackAttrs}>
      {children}
      {isOpened && (
        <div
          className="absolute flex flex-col items-center w-auto"
          style={style}
        >
          <div className="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black shadow-lg w-max">
            {tooltipChildren}
          </div>
        </div>
      )}
    </div>
  );
}

Tooltip.propTypes = {
  className: PropTypes.string,
  controlled: PropTypes.bool.isRequired,
  open: PropTypes.bool,
  children: PropTypes.any.isRequired,
  placement: PropTypes.string.isRequired,
  tooltipChildren: PropTypes.any.isRequired,
};

Tooltip.defaultProps = {
  controlled: false,
  open: false,
  placement: "bottom",
  className: "",
};
